import React, { useState, useEffect, useRef, forwardRef } from "react";

import {
  Button,
  Dialog,
  Divider,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Box,
} from "@mui/material";

import moment from "moment";

import Notes from "@components/patients/Notes";
import EpisodesOfCare from "@components/patients/EpisodesOfCare";

import { useReactToPrint } from "react-to-print";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import CloseIcon from "@mui/icons-material/Close";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Report({
  isVisible,
  onCloseReport,
  dataPatient,
  dataPatientObservations,
  dataPatientAssessments,
  dataPatientEOC,
  dataPatientLatestNotes,
  ...props
}) {
  const [loading, setLoading] = useState(false);

  const [isPatientDetailsSelected, setIsPatientDetailsSelected] =
    useState(true);
  const [isPatientEOCSelected, setIsPatientEOCSelected] = useState(true);
  const [isPatientNotesSelected, setIsPatientNotesSelected] = useState(true);
  const [isPatientNEWSGraphSelected, setIsPatientNEWSGraphSelected] =
    useState(true);
  const [isPatientRRGraphSelected, setIsPatientRRGraphSelected] =
    useState(true);
  const [isPatientSPO2GraphSelected, setIsPatientSPO2GraphSelected] =
    useState(true);
  const [
    isPatientHR_SYS_DIAGraphSelected,
    setIsPatientHR_SYS_DIAGraphSelected,
  ] = useState(true);
  const [
    isPatientTemperatureGraphSelected,
    setIsPatientTemperatureGraphSelected,
  ] = useState(true);
  const [isPatientWeightGraphSelected, setIsPatientWeightGraphSelected] =
    useState(true);
  const [isPatientPainGraphSelected, setIsPatientPainGraphSelected] =
    useState(true);

  const [isPatientWaterlowGraphSelected, setIsPatientWaterlowGraphSelected] =
    useState(true);
  const [isPatientMMSEGraphSelected, setIsPatientMMSEGraphSelected] =
    useState(true);
  const [isPatientBarthelGraphSelected, setIsPatientBarthelGraphSelected] =
    useState(true);
  const [isPatientFrailtyGraphSelected, setIsPatientFrailtyGraphSelected] =
    useState(true);
  const [isPatientMustGraphSelected, setIsPatientMustGraphSelected] =
    useState(true);

  const [isAllSelected, setIsAllSelected] = useState(true);

  const componentRef = useRef();

  useEffect(() => {
    const allSelected =
      isPatientDetailsSelected &&
      isPatientEOCSelected &&
      isPatientNotesSelected &&
      isPatientNEWSGraphSelected &&
      isPatientRRGraphSelected &&
      isPatientSPO2GraphSelected &&
      isPatientHR_SYS_DIAGraphSelected &&
      isPatientTemperatureGraphSelected &&
      isPatientWeightGraphSelected &&
      isPatientPainGraphSelected &&
      isPatientWaterlowGraphSelected &&
      isPatientMMSEGraphSelected &&
      isPatientBarthelGraphSelected &&
      isPatientFrailtyGraphSelected &&
      isPatientMustGraphSelected;

    if (!allSelected) {
      setIsAllSelected(false);
    }
  }, [
    isPatientDetailsSelected,
    isPatientEOCSelected,
    isPatientNotesSelected,
    isPatientNEWSGraphSelected,
    isPatientRRGraphSelected,
    isPatientSPO2GraphSelected,
    isPatientHR_SYS_DIAGraphSelected,
    isPatientTemperatureGraphSelected,
    isPatientWeightGraphSelected,
    isPatientPainGraphSelected,
    isPatientWaterlowGraphSelected,
    isPatientMMSEGraphSelected,
    isPatientBarthelGraphSelected,
    isPatientFrailtyGraphSelected,
    isPatientMustGraphSelected,
  ]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const formatDate = (date) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return new Intl.DateTimeFormat("en-GB", options).format(new Date(date));
  };

  const formatLabelDate = (value) =>
    new Date(value).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  const CustomizedLabel = ({ x, y, value }) => {
    return (
      <text x={x} y={y} dy={-10} fontSize={14} textAnchor="middle">
        {value}
      </text>
    );
  };

  const setAllSelected = (value) => {
    if (value) {
      setIsPatientDetailsSelected(true);
      setIsPatientEOCSelected(true);
      setIsPatientNotesSelected(true);
      setIsPatientNEWSGraphSelected(true);
      setIsPatientRRGraphSelected(true);
      setIsPatientSPO2GraphSelected(true);
      setIsPatientHR_SYS_DIAGraphSelected(true);
      setIsPatientTemperatureGraphSelected(true);
      setIsPatientWeightGraphSelected(true);
      setIsPatientPainGraphSelected(true);

      setIsPatientWaterlowGraphSelected(true);
      setIsPatientMMSEGraphSelected(true);
      setIsPatientFrailtyGraphSelected(true);
      setIsPatientBarthelGraphSelected(true);
      setIsPatientMustGraphSelected(true);

      setIsAllSelected(true);
    } else {
      setIsPatientDetailsSelected(false);
      setIsPatientEOCSelected(false);
      setIsPatientNotesSelected(false);
      setIsPatientNEWSGraphSelected(false);
      setIsPatientRRGraphSelected(false);
      setIsPatientSPO2GraphSelected(false);
      setIsPatientHR_SYS_DIAGraphSelected(false);
      setIsPatientTemperatureGraphSelected(false);
      setIsPatientWeightGraphSelected(false);
      setIsPatientPainGraphSelected(false);
      setIsPatientWaterlowGraphSelected(false);
      setIsPatientMMSEGraphSelected(false);
      setIsPatientFrailtyGraphSelected(false);
      setIsPatientBarthelGraphSelected(false);
      setIsPatientMustGraphSelected(false);

      setIsAllSelected(false);
    }
  };

  return (
    <Dialog
      fullScreen
      open={isVisible}
      onClose={onCloseReport}
      TransitionComponent={Transition}
      PaperProps={{
        style: {
          backgroundColor: "#FFF",
          boxShadow: "none",
        },
      }}
    >
      <AppBar sx={{ position: "relative" }} color="primary">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onCloseReport}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography
            sx={{ ml: 2, flex: 1 }}
            style={{ paddingLeft: 8 }}
            variant="h6"
            component="div"
          >
            {dataPatient.firstname + " " + dataPatient.surname}
          </Typography>
        </Toolbar>
      </AppBar>

      <Box
        style={{
          margin: 16,
        }}
      >
        {loading ? (
          <CircularProgress color="primary" />
        ) : (
          <>
            <Grid
              container
              spacing={2}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Grid
                item
                xs={12}
                md={12}
                style={{
                  display: "flex",
                  //justifyContent: "center",
                }}
              >
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientDetailsSelected}
                        onChange={(e) =>
                          setIsPatientDetailsSelected(e.target.checked)
                        }
                        name="patient_details"
                        color="primary"
                      />
                    }
                    label="Patient Details"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientEOCSelected}
                        onChange={(e) =>
                          setIsPatientEOCSelected(e.target.checked)
                        }
                        name="episodes_of_care"
                        color="primary"
                      />
                    }
                    label="Episodes of Care"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientNotesSelected}
                        onChange={(e) =>
                          setIsPatientNotesSelected(e.target.checked)
                        }
                        name="notes"
                        color="primary"
                      />
                    }
                    label="Notes"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientNEWSGraphSelected}
                        onChange={(e) =>
                          setIsPatientNEWSGraphSelected(e.target.checked)
                        }
                        name="news_graph"
                        color="primary"
                      />
                    }
                    label="NEWS Graph"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientRRGraphSelected}
                        onChange={(e) =>
                          setIsPatientRRGraphSelected(e.target.checked)
                        }
                        name="respiratory_rate_graph"
                        color="primary"
                      />
                    }
                    label="Respiratory Rate Graph"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientSPO2GraphSelected}
                        onChange={(e) =>
                          setIsPatientSPO2GraphSelected(e.target.checked)
                        }
                        name="spo2_graph"
                        color="primary"
                      />
                    }
                    label="Spo2 Graph"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientHR_SYS_DIAGraphSelected}
                        onChange={(e) =>
                          setIsPatientHR_SYS_DIAGraphSelected(e.target.checked)
                        }
                        name="hr_sys_dia_graph"
                        color="primary"
                      />
                    }
                    label="Hr/Sys/Dia Graph"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientTemperatureGraphSelected}
                        onChange={(e) =>
                          setIsPatientTemperatureGraphSelected(e.target.checked)
                        }
                        name="temperature_graph"
                        color="primary"
                      />
                    }
                    label="Temperature Graph"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientWeightGraphSelected}
                        onChange={(e) =>
                          setIsPatientWeightGraphSelected(e.target.checked)
                        }
                        name="weight_graph"
                        color="primary"
                      />
                    }
                    label="Weight Graph"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientPainGraphSelected}
                        onChange={(e) =>
                          setIsPatientPainGraphSelected(e.target.checked)
                        }
                        name="pain_graph"
                        color="primary"
                      />
                    }
                    label="Pain Graph"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientWaterlowGraphSelected}
                        onChange={(e) =>
                          setIsPatientWaterlowGraphSelected(e.target.checked)
                        }
                        name="waterlow_graph"
                        color="primary"
                      />
                    }
                    label="Waterlow Graph"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientMMSEGraphSelected}
                        onChange={(e) =>
                          setIsPatientMMSEGraphSelected(e.target.checked)
                        }
                        name="mmse_graph"
                        color="primary"
                      />
                    }
                    label="MMSE Graph"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientFrailtyGraphSelected}
                        onChange={(e) =>
                          setIsPatientFrailtyGraphSelected(e.target.checked)
                        }
                        name="frailty_graph"
                        color="primary"
                      />
                    }
                    label="Frailty Graph"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientBarthelGraphSelected}
                        onChange={(e) =>
                          setIsPatientBarthelGraphSelected(e.target.checked)
                        }
                        name="barthel_graph"
                        color="primary"
                      />
                    }
                    label="Barthel Graph"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPatientMustGraphSelected}
                        onChange={(e) =>
                          setIsPatientMustGraphSelected(e.target.checked)
                        }
                        name="must_graph"
                        color="primary"
                      />
                    }
                    label="MUST Graph"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isAllSelected}
                        onChange={(e) => setAllSelected(e.target.checked)}
                        name="all_selected"
                        color="primary"
                      />
                    }
                    label="All"
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={12} style={{}}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{}}
                  onClick={() => {
                    //window.print();
                    //this.setState({ isReportVisible: true });
                    //fetchData();

                    handlePrint();
                  }}
                >
                  Print Preview
                </Button>
              </Grid>

              <Grid item xs={12} md={12} style={{}}>
                <Divider />
              </Grid>
            </Grid>
            <Box style={{ margin: 50 }} ref={componentRef}>
              <Grid
                container
                spacing={1}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Grid
                  item
                  xs={12}
                  md={4}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    padding: 15,
                  }}
                >
                  <Typography style={{ textAlign: "left" }}>
                    {"Location: " + dataPatient.hospital_name}
                  </Typography>
                  <Typography style={{ textAlign: "left" }}>
                    {"Ward: " + dataPatient.ward_name}
                  </Typography>
                  <Typography style={{ textAlign: "left" }}>
                    {!isNullOrEmpty(dataPatient.consultant)
                      ? "Consultant: " + dataPatient.consultant
                      : "Consultant: -"}
                  </Typography>
                  <Typography style={{ textAlign: "left" }}>
                    {!isNullOrEmpty(dataPatient.room_name)
                      ? "Room: " + dataPatient.room_name
                      : "Room: -"}
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={4}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    padding: 15,
                  }}
                >
                  <Typography
                    variant="h5"
                    style={{ textAlign: "center", fontWeight: "bold" }}
                  >
                    {dataPatient.firstname + " " + dataPatient.surname}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    style={{ textAlign: "center" }}
                  >
                    Patient Report
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "end",
                    padding: 15,
                  }}
                >
                  <img
                    src="https://www.chartermedical.ie/wp-content/uploads/2020/10/logo.jpg"
                    alt="logo"
                    style={{ height: 50 }}
                  />
                </Grid>
                {isPatientDetailsSelected && (
                  <Grid item xs={12} md={12} style={{ margin: 10 }}>
                    <Typography variant="h6" style={{}}>
                      PATIENT DETAILS
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <Grid
                      container
                      spacing={1}
                      style={{ marginLeft: 10, marginRight: 10 }}
                    >
                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle2">Firstname</Typography>
                        <Typography>{dataPatient.firstname}</Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle2">Surname</Typography>
                        <Typography>{dataPatient.surname}</Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle2">Gender</Typography>
                        <Typography>
                          {dataPatient.gender === "m"
                            ? "Male"
                            : dataPatient.gender === "u"
                            ? "Unknown"
                            : "Female"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle2">DOB</Typography>
                        <Typography>
                          {moment(dataPatient.dob).format("DD/MM/YYYY")}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle2">MRN</Typography>
                        <Typography>
                          {!isNullOrEmpty(dataPatient.mrn)
                            ? dataPatient.mrn
                            : "-"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle2">Phone</Typography>
                        <Typography>
                          {!isNullOrEmpty(dataPatient.phone)
                            ? dataPatient.phone
                            : "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant="subtitle2">Address</Typography>
                        <Typography>
                          {!isNullOrEmpty(dataPatient.address)
                            ? dataPatient.address
                            : "-"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2">
                          Admitted Note
                        </Typography>
                        <Typography>
                          {!isNullOrEmpty(dataPatient.note)
                            ? dataPatient.note
                            : "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle2">
                          Emergency Contact Name
                        </Typography>
                        <Typography>
                          {!isNullOrEmpty(dataPatient.emergency_name)
                            ? dataPatient.emergency_name
                            : "-"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle2">
                          Emergency Contact Number
                        </Typography>
                        <Typography>
                          {!isNullOrEmpty(dataPatient.emergency_phone)
                            ? dataPatient.emergency_phone
                            : "-"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle2">
                          Emergency Contact Relationship
                        </Typography>
                        <Typography>
                          {!isNullOrEmpty(dataPatient.relationship)
                            ? dataPatient.relationship
                            : "-"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}></Grid>
                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle2">Status</Typography>
                        <Typography>
                          {dataPatient.status === 0 ? "Admitted" : "Discharged"}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle2">
                          Admitted Date
                        </Typography>
                        <Typography>
                          {dataPatient.admitted_date !== null
                            ? moment(dataPatient.admitted_date).format(
                                "DD/MM/YYYY"
                              )
                            : "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <Typography variant="subtitle2">
                          Expected Discharge Date
                        </Typography>
                        <Typography>
                          {moment(dataPatient.exptected_discharge_date).format(
                            "DD/MM/YYYY"
                          )}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle2">
                          Days Since Admission
                        </Typography>
                        <Typography>
                          {dataPatient.admitted_date !== null
                            ? moment()
                                .startOf("day")
                                .diff(moment(dataPatient.admitted_date), "days")
                            : "-"}
                        </Typography>
                      </Grid>

                      {dataPatient.status === 1 && (
                        <Grid item xs={12} md={4}>
                          <Typography variant="subtitle2">
                            Discharge Date
                          </Typography>
                          <Typography>
                            {moment(dataPatient.discharge_date).format(
                              "DD/MM/YYYY"
                            )}
                          </Typography>
                        </Grid>
                      )}

                      <Grid item xs={12}>
                        <Typography variant="subtitle2">
                          Discharge Note
                        </Typography>
                        <Typography>
                          {!isNullOrEmpty(dataPatient.discharge_note)
                            ? dataPatient.discharge_note
                            : "-"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                {isPatientEOCSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      EPISODES OF CARE
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <EpisodesOfCare
                      headings={[
                        "Date",
                        "Event Type",
                        "Discharge Note",
                        "Facility",
                      ]}
                      data={dataPatientEOC}
                    />
                  </Grid>
                )}

                {isPatientNotesSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      LATEST NOTES
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <Notes
                      headings={["Date", "Title", "Note"]}
                      data={dataPatientLatestNotes}
                    />
                  </Grid>
                )}

                {isPatientNEWSGraphSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      NEWS OBSERVATION GRAPH
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <ResponsiveContainer width="100%" height={600}>
                      <LineChart
                        data={dataPatientObservations}
                        margin={{ top: 0, left: 0, right: 50, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="timestamp" tickFormatter={formatDate} />
                        <YAxis />
                        <Tooltip labelFormatter={formatLabelDate} />
                        <Legend
                          verticalAlign="top"
                          layout="horizontal"
                          wrapperStyle={{ padding: 20 }}
                          //margin={[10, 0, 10, 0]}
                        />
                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="news_score"
                          stroke="#5C6BC0"
                          fill="#5C6BC0"
                          label={<CustomizedLabel />}
                          name="NEWS"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Grid>
                )}

                {isPatientRRGraphSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      RESPIRATORY RATE OBSERVATION GRAPH
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <ResponsiveContainer width="100%" height={600}>
                      <LineChart
                        data={dataPatientObservations}
                        margin={{ top: 0, left: 0, right: 50, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="timestamp" tickFormatter={formatDate} />
                        <YAxis
                          type="number"
                          domain={["dataMin - 5", "dataMax + 5"]}
                        />
                        <Tooltip labelFormatter={formatLabelDate} />
                        <Legend
                          verticalAlign="top"
                          layout="horizontal"
                          wrapperStyle={{ padding: 20 }}
                          //margin={[10, 0, 10, 0]}
                        />
                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="resp_rate"
                          stroke="#be308f"
                          fill="#be308f"
                          label={<CustomizedLabel />}
                          name="Respiratory Rate"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Grid>
                )}

                {isPatientSPO2GraphSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      SPO2 OBSERVATION GRAPH
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <ResponsiveContainer width="100%" height={600}>
                      <LineChart
                        data={dataPatientObservations}
                        margin={{ top: 0, left: 0, right: 50, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="timestamp" tickFormatter={formatDate} />
                        <YAxis
                          type="number"
                          domain={["dataMin - 5", "dataMax + 5"]}
                        />
                        <Tooltip labelFormatter={formatLabelDate} />
                        <Legend
                          verticalAlign="top"
                          layout="horizontal"
                          wrapperStyle={{ padding: 20 }}
                          //margin={[10, 0, 10, 0]}
                        />
                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="oximeter"
                          stroke="#00BFFF"
                          fill="#00BFFF"
                          label={<CustomizedLabel />}
                          name="SpO2"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Grid>
                )}

                {isPatientHR_SYS_DIAGraphSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      HR/SYS/DIA OBSERVATION GRAPH
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <ResponsiveContainer width="100%" height={600}>
                      <LineChart
                        data={dataPatientObservations}
                        margin={{ top: 0, left: 0, right: 50, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="timestamp" tickFormatter={formatDate} />
                        <YAxis
                          type="number"
                          domain={["dataMin - 5", "dataMax + 5"]}
                        />
                        <Tooltip labelFormatter={formatLabelDate} />
                        <Legend
                          verticalAlign="top"
                          layout="horizontal"
                          wrapperStyle={{ padding: 20 }}
                          //margin={[10, 0, 10, 0]}
                        />
                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="bpm"
                          stroke="#FF5733"
                          fill="#FF5733"
                          label={<CustomizedLabel />}
                          name="Heart Rate"
                        />

                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="sys"
                          stroke="#FFA500"
                          fill="#FFA500"
                          label={<CustomizedLabel />}
                          name="Systolic"
                        />

                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="dia"
                          stroke="#9370DB"
                          fill="#9370DB"
                          label={<CustomizedLabel />}
                          name="Diastolic"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Grid>
                )}

                {isPatientTemperatureGraphSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      TEMPERATURE OBSERVATION GRAPH
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <ResponsiveContainer width="100%" height={600}>
                      <LineChart
                        data={dataPatientObservations}
                        margin={{ top: 0, left: 0, right: 50, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="timestamp" tickFormatter={formatDate} />
                        <YAxis
                          type="number"
                          domain={["dataMin - 5", "dataMax + 5"]}
                        />
                        <Tooltip labelFormatter={formatLabelDate} />
                        <Legend
                          verticalAlign="top"
                          layout="horizontal"
                          wrapperStyle={{ padding: 20 }}
                          //margin={[10, 0, 10, 0]}
                        />
                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="temperature"
                          stroke="#2ade2a"
                          fill="#2ade2a"
                          label={<CustomizedLabel />}
                          name="Temperature"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Grid>
                )}

                {isPatientWeightGraphSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      WEIGHT OBSERVATION GRAPH
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <ResponsiveContainer width="100%" height={600}>
                      <LineChart
                        data={dataPatientObservations}
                        margin={{ top: 0, left: 0, right: 50, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="timestamp" tickFormatter={formatDate} />
                        <YAxis
                          type="number"
                          domain={["dataMin - 5", "dataMax + 5"]}
                        />
                        <Tooltip labelFormatter={formatLabelDate} />
                        <Legend
                          verticalAlign="top"
                          layout="horizontal"
                          wrapperStyle={{ padding: 20 }}
                          //margin={[10, 0, 10, 0]}
                        />
                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="weight"
                          stroke="#5e0c66"
                          fill="#5e0c66"
                          label={<CustomizedLabel />}
                          name="Weight"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Grid>
                )}

                {isPatientPainGraphSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      PAIN OBSERVATION GRAPH
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <ResponsiveContainer width="100%" height={600}>
                      <LineChart
                        data={dataPatientObservations}
                        margin={{ top: 0, left: 0, right: 50, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="timestamp" tickFormatter={formatDate} />
                        <YAxis />
                        <Tooltip labelFormatter={formatLabelDate} />
                        <Legend
                          verticalAlign="top"
                          layout="horizontal"
                          wrapperStyle={{ padding: 20 }}
                          //margin={[10, 0, 10, 0]}
                        />
                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="pain_level"
                          stroke="#3DAC95"
                          fill="#3DAC95"
                          label={<CustomizedLabel />}
                          name="Pain"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Grid>
                )}

                {isPatientWaterlowGraphSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      WATERLOW ASSESSMENT GRAPH
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <ResponsiveContainer width="100%" height={600}>
                      <LineChart
                        data={dataPatientAssessments}
                        margin={{ top: 0, left: 0, right: 50, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="timestamp" tickFormatter={formatDate} />
                        <YAxis />
                        <Tooltip labelFormatter={formatLabelDate} />
                        <Legend
                          verticalAlign="top"
                          layout="horizontal"
                          wrapperStyle={{ padding: 20 }}
                          //margin={[10, 0, 10, 0]}
                        />
                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="waterlow_total_score"
                          stroke="#555498"
                          fill="#555498"
                          label={<CustomizedLabel />}
                          name="Waterlow"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Grid>
                )}

                {isPatientMMSEGraphSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      MMSE ASSESSMENT GRAPH
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <ResponsiveContainer width="100%" height={600}>
                      <LineChart
                        data={dataPatientAssessments}
                        margin={{ top: 0, left: 0, right: 50, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="timestamp" tickFormatter={formatDate} />
                        <YAxis />
                        <Tooltip labelFormatter={formatLabelDate} />
                        <Legend
                          verticalAlign="top"
                          layout="horizontal"
                          wrapperStyle={{ padding: 20 }}
                          //margin={[10, 0, 10, 0]}
                        />
                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="mmse_total_score"
                          stroke="#6d4f7d"
                          fill="#6d4f7d"
                          label={<CustomizedLabel />}
                          name="MMSE"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Grid>
                )}

                {isPatientFrailtyGraphSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      FRAILTY ASSESSMENT GRAPH
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <ResponsiveContainer width="100%" height={600}>
                      <LineChart
                        data={dataPatientAssessments}
                        margin={{ top: 0, left: 0, right: 50, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="timestamp" tickFormatter={formatDate} />
                        <YAxis />
                        <Tooltip labelFormatter={formatLabelDate} />
                        <Legend
                          verticalAlign="top"
                          layout="horizontal"
                          wrapperStyle={{ padding: 20 }}
                          //margin={[10, 0, 10, 0]}
                        />
                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="frailty_total_score"
                          stroke="#0bb3f1"
                          fill="#0bb3f1"
                          label={<CustomizedLabel />}
                          name="Frailty"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Grid>
                )}

                {isPatientBarthelGraphSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      BARTHEL ASSESSMENT GRAPH
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <ResponsiveContainer width="100%" height={600}>
                      <LineChart
                        data={dataPatientAssessments}
                        margin={{ top: 0, left: 0, right: 50, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="timestamp" tickFormatter={formatDate} />
                        <YAxis />
                        <Tooltip labelFormatter={formatLabelDate} />
                        <Legend
                          verticalAlign="top"
                          layout="horizontal"
                          wrapperStyle={{ padding: 20 }}
                          //margin={[10, 0, 10, 0]}
                        />
                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="barthel_total_score"
                          stroke="#d76532"
                          fill="#d76532"
                          label={<CustomizedLabel />}
                          name="Barthel"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Grid>
                )}

                {isPatientMustGraphSelected && (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ margin: 10, pageBreakBefore: "always" }}
                  >
                    <Typography variant="h6" style={{}}>
                      MUST ASSESSMENT GRAPH
                    </Typography>
                    <Divider
                      orientation="horizontal"
                      variant="fullWidth"
                      style={{ padding: 2, marginBottom: 15 }}
                    />
                    <ResponsiveContainer width="100%" height={600}>
                      <LineChart
                        data={dataPatientAssessments}
                        margin={{ top: 0, left: 0, right: 50, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="timestamp" tickFormatter={formatDate} />
                        <YAxis />
                        <Tooltip labelFormatter={formatLabelDate} />
                        <Legend
                          verticalAlign="top"
                          layout="horizontal"
                          wrapperStyle={{ padding: 20 }}
                          //margin={[10, 0, 10, 0]}
                        />
                        <Line
                          type="monotone"
                          connectNulls
                          dataKey="must_total_score"
                          stroke="#018599"
                          fill="#018599"
                          label={<CustomizedLabel />}
                          name="MUST"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Grid>
                )}
              </Grid>
            </Box>
          </>
        )}
      </Box>
    </Dialog>
  );
}
